import { render, staticRenderFns } from "./AddCaptain.vue?vue&type=template&id=75e1f9d0"
import script from "./AddCaptain.vue?vue&type=script&lang=js"
export * from "./AddCaptain.vue?vue&type=script&lang=js"
import style0 from "./AddCaptain.vue?vue&type=style&index=0&id=75e1f9d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports